<template>
  <div class="login-page" v-show="showPage">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="login-title">聊天系统</span>
      </div>
      <div class="login-form">
        <el-form :model="form" :rules="loginRules" ref="loginForm">
          <el-form-item prop="userName">
            <el-input type="text" v-model="form.userName" auto-complete="off" placeholder="请输入账号">
              <template slot="prepend"><i style="font-size:20px" class="el-icon-user"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="passWord">
            <el-input type="password" v-model="form.passWord" auto-complete="off" placeholder="请输入密码">
              <template slot="prepend"><i style="font-size:20px" class="el-icon-key"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width:100%;" type="primary" @click="handleLogin" :loading="loading">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    //这里存放数据
    return {
      showPage: 0,
      loading: false,
      form: {
        userName: '',
        passWord: ''
      },
      loginRules: {
        userName: [
          { required: true, message: '请输入账户', trigger: 'blur' },
        ],
        passWord: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleLogin() {
      this.loading = true;
      this.$getRequest("kefu/login/login", {
        username: this.form.userName,
        password: this.form.passWord
      }).then((res) => {
        if (res.code == 200) {
          window.localStorage.setItem("isKf", 1);
          window.localStorage.setItem("token", res.data.token);
          window.localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.websocket.Init();
          setTimeout(() => {
            this.$router.push('./');
            this.loading = false;
          }, 1000)
        } else {
          this.loading = false;
        }
      });
    }
  },
  beforeMount() {
    //userInfo nickname avatar id token
    function getUrlParam(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      }
      else {
        return "";
      }
    }

    let token = getUrlParam("token");
    let userInfo = {
      nickname: getUrlParam("nickname"),
      avatar: getUrlParam("avatar"),
      id: getUrlParam("id"),
      to_uid: getUrlParam("to_uid"),
      token: token
    }
    if (token) {
      window.localStorage.setItem("isKf", 0);
      window.localStorage.setItem("token", token);
      window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
      this.$router.push('./');
    }
    this.showPage = 1

  },
};
</script>
<style lang="less" scoped>
.login-page {
  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-title {
  font-size: 20px;
}

.box-card {
  width: 375px;
}
</style>
